import qs from "query-string";

import { createApiV2 } from "./common";

export const getTimesheetSummary = (params) => (token) =>
  createApiV2("GET", `timesheets/summary/?${qs.stringify(params)}`)(token);

export const patchBulkChangeTimeEntryStatus =
  ({ data }) =>
  (token) =>
    createApiV2("PATCH", `timesheets/bulk_change_status/`)(token, data);

export const getOrderNumbers = (params) => (token) =>
  createApiV2("GET", `order_number/?${qs.stringify(params)}`)(token);

export const postValidateUserPin = (data) => (token) =>
  createApiV2("POST", `users/pin/`)(token, data);

export const deleteTimeEntry = (data) => (token) =>
  createApiV2("DELETE", `timesheets/bulk_delete/`)(token, data);

export const postDownloadTimesheets =
  ({ data }) =>
  (token) =>
    createApiV2("POST", `timesheets/download/`)(token, data);

export const postExportAllTimesheets =
  ({ data }) =>
  (token) =>
    createApiV2("POST", `timesheets/export_all/`)(token, data);

export const postExportTimeEntriesTimesheets =
  ({ data }) =>
  (token) =>
    createApiV2("POST", `timesheets/export/`)(token, data);

export const getTimeTrackingBreaks = (params) => (token) =>
  createApiV2("GET", `timesheet_breaks/?${qs.stringify(params)}`)(token);

export const getCompanyBreaks = (params) => (token) =>
  createApiV2("GET", `company_breaks/?${qs.stringify(params)}`)(token);

export const patchCompanyBreaks = (uid, data) => (token) =>
  createApiV2("PATCH", `company_breaks/${uid}/`)(token, data);

export const postCompanyBreaks = (data) => (token) =>
  createApiV2("POST", `company_breaks/`)(token, data);

export const deleteCompanyBreaks = (uid) => (token) =>
  createApiV2("DELETE", `company_breaks/${uid}/`)(token);
